import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { PaymentManagementData } from "modules/PaymentManagement/components";
import { useAuth } from "context/authContext";
import { PaymentMethodsTypes } from "types";
import { PaymentMethodService } from "services/PaymentMethodService";

type Props = {};

const PaymentManagementContainer = (props: Props) => {
  return (
    <AppLayout>
      <PaymentManagementData />
    </AppLayout>
  );
};

export default PaymentManagementContainer;
